import React, { Component } from "react";
import "./NodeModal.css";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Input,
  Label,
} from "reactstrap";

export default class NodeModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      network: this.props.network,
      validationError: [],
      isValid: true,
    };
  }

  validateInput = () => {
    this.setState({ isValid: true, validationErrors: [] });
    return true;
  };

  handleChange = (e) => {
    let { name, value } = e.target;
    const network = { ...this.state.network, [name]: value };
    this.setState({ network });
  };
  render() {
    const { toggle, getErrors, onSave, toggleName } = this.props;

    return (
      <Modal modalClassName="Modal" isOpen={true} toggle={function(){ return toggle(toggleName);}}>
        <ModalHeader>
          New network
          <button className="exit_close_button" onClick={function(){ return toggle(toggleName);}}>
            ×
          </button>
        </ModalHeader>

        <div className="val_error_area">
          <ul style={{ color: "red" }}>
            {this.state.isValid ? getErrors() : this.state.validationErrors}
          </ul>
        </div>
        <ModalBody>
          <Form
            onSubmit={(event) => {
              event.preventDefault();
            }}
          >
            <FormGroup className="fg">
              <Label for="name">Name</Label>
              <Input
                type="text"
                name="name"
                value={this.state.network.name}
                onChange={this.handleChange}
                placeholder="Enter network name"
                maxLength="50"
              />
            </FormGroup>
            <FormGroup className="fg">
              <Label for="description">Description</Label>
              <Input
                type="text"
                name="description"
                value={this.state.network.description}
                onChange={this.handleChange}
                placeholder="Enter network description"
                maxLength="1000"
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <button
            className="save_button"
            color="success"
            onClick={() => {
              if (this.validateInput()) {
                onSave(this.state.network);
              }
            }}
          >
            Create
          </button>
        </ModalFooter>
      </Modal>
    );
  }
}
